import { render, staticRenderFns } from "./email-profile.vue?vue&type=template&id=50a6a8ce&scoped=true"
import script from "./email-profile.vue?vue&type=script&lang=js"
export * from "./email-profile.vue?vue&type=script&lang=js"
import style0 from "./email-profile.vue?vue&type=style&index=0&id=50a6a8ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a6a8ce",
  null
  
)

export default component.exports